<template>
    <div class="device-type-add">
        <el-page-header @back="goBack" :content="page_title"></el-page-header>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="form"
                 :style="{width: form_width,margin: '20px auto 0 auto'}" autocomplete="off">
            <el-form-item label="宣传广告标题" prop="title">
                <el-input type="text" v-model="ruleForm.title" placeholder="请输入宣传广告标题" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="所属角色" prop="role_id">
                <el-select v-model="ruleForm.role_id" @change="roleChange"
                           placeholder="请选择所属角色"
                           style="width:100%;">
                    <el-option
                        v-for="item in user_role "
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="广告类型" prop="type" v-if="ruleForm.role_id != 11 && ruleForm.role_id != 31">
                <el-select v-model="ruleForm.type"
                           placeholder="请选择广告类型"
                           style="width:100%;">
                    <el-option
                        v-for="item in type "
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="广告类型" prop="type" v-if="ruleForm.role_id == 11 || ruleForm.role_id == 31">
                <el-select v-model="ruleForm.type" :disabled="true"
                           placeholder="请选择广告类型"
                           style="width:100%;">
                    <el-option
                        v-for="item in type "
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="宣传视频" prop="content" v-if="ruleForm.type ==1">
                <el-upload
                    :action="upload_path"
                    accept=".mp4"
                    :on-preview="handleVideoPreview"
                    :on-success="handleVideoSuccess"
                    :on-remove="handleVideoRemove"
                    :before-upload="beforeVideoUpload"
                    :show-file-list="true"
                    :file-list="videoList"
                    :limit="1"
                    class="videoUpload"
                >
                    <video v-if="isShow"  width="100%" controls="controls" :src="videoUrl" class="avatar"></video>
                    <el-button class="upload_btn"  v-else size="small" type="primary">点击上传</el-button>
                </el-upload>
                <el-dialog class="video-dialog" :visible.sync="dialogVisible" append-to-body>
                    <video width="100%" controls="controls" style="object-fit: contain;max-height: 760px;"  :src="videoUrl"></video>
                </el-dialog>
            </el-form-item>

            <el-form-item label="宣传图片" prop="content" v-if="ruleForm.type == 2">
                <el-upload ref="upload" class="upload-demo" accept=".jpg,.png,.jpeg,.JPEG,.JPG,.PNG"
                           :action="upload_agreement_path" :file-list="fileList"
                           :on-success="handleSuccess" :before-upload="beforeUpload" list-type="picture"
                           :multiple="true" :limit="5">
                    <div slot="file" slot-scope="{file}">
                        <img class="el-upload-list__item-thumbnail" :src="file.url" alt=""/>
                        <a class="el-upload-list__item-name"><i class="el-icon-document"></i>{{ file.name }}</a>
                        <label class="el-upload-list__item-status-label">
                            <i class="el-icon-upload-success el-icon-check"></i>
                        </label>
                        <i class="el-icon-close" @click="handleRemove(file)"></i>
                        <i class="el-icon-close-tip">按 delete 键可删除</i>
                    </div>

                    <el-button class="upload_btn" size="small" type="primary" v-if="addFileList.length < 9">点击上传
                    </el-button>
                    <div slot="tip" class="el-upload__tip" v-if="addFileList.length < 9">注：请上传小于5M的图片，格式支持PNG,JPG,PDF
                    </div>
                </el-upload>

                <div class="upload-demo">
                    <el-button class="file_view" size="small" type="primary"
                               @click="pictureView({contract_file: JSON.stringify(addFileList)})">图片预览
                    </el-button>
                </div>
            </el-form-item>

            <el-form-item label="广告文本" prop="content" v-if="ruleForm.type == 3 || ruleForm.type == 5">
                <el-input type="textarea" v-model="ruleForm.content"
                          autosize
                          :maxlength="maxlength"
                          show-word-limit
                          placeholder="请输入广告文本" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>

<!--            <el-form-item label="广告封面" prop="article_title" v-if="ruleForm.type != 2 && ruleForm.type != 3">-->
<!--                <el-upload-->
<!--                    class="avatar-uploader"-->
<!--                    :action="upload_path"-->
<!--                    :show-file-list="false"-->
<!--                    :on-success="handleThumbSuccess"-->
<!--                    :before-upload="beforeUpload">-->
<!--                    <img v-if="thumbUrl" :src="thumbUrl" class="avatar">-->
<!--                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>-->
<!--                </el-upload>-->
<!--            </el-form-item>-->
            <el-form-item label="内容" prop="content" style="margin:0px 0px 130px 0px;"
                          v-if="ruleForm.id && ruleForm.type != 1 && ruleForm.type != 2 && ruleForm.type != 3 && ruleForm.type != 5">
                <div>(如需上传,请选择小于5M的图片)</div>
                <me-wang-editor  v-model="ruleForm.content"></me-wang-editor>
            </el-form-item>
            <el-form-item label="内容" prop="content" style="margin:0px 0px 130px 0px;"
                          v-if="!ruleForm.id && ruleForm.type == 4">
                <div>(如需上传,请选择小于5M的图片)</div>
                <me-wang-editor  v-model="ruleForm.content"></me-wang-editor>
            </el-form-item>
            <!-- form表单提交 -->
            <el-form-item>
                <el-button @click="goBack">取消</el-button>
                <el-button type="success" @click="submitForm('ruleForm')">保存</el-button>
            </el-form-item>
        </el-form>
        <el-dialog title="图片预览" :visible.sync="dialogPictureVisible">
            <el-carousel indicator-position="outside" height="500px" :autoplay="false">
                <el-carousel-item v-for="url in allContractUrls" :key="url">
                    <div class="image_box">
                        <pdf :src="url" v-if="getFileType(url) == 'pdf'"></pdf>
                        <el-image :src="url" v-else></el-image>
                    </div>
                </el-carousel-item>
            </el-carousel>
        </el-dialog>
    </div>
</template>
<script>
import env from "@/api/env";
import {getUserInfos} from '@/utils/userInfos';
import {getFormatDate} from "@/utils/date";
import {check} from "@/utils/checkData";
import {fileType, isMobile} from "@/api/order";


export default {
    props: {
        /*编辑器的内容*/
        value: {
            type: String
        },
        /*图片大小*/
        maxSize: {
            type: Number,
            default: 5120 //kb
        }
    },
    computed: {},
    created() {
        if (isMobile()) {
            this.form_width = "100%"
        }
        if (this.$route.params.id) {
            this.ruleForm.id = this.$route.params.id;
            this.page_title = "编辑宣传广告";
            this.getDetails();
        } else {
            this.page_title = "添加宣传广告";
        }
    },
    mounted() {

    },
    data() {
        return {
            page_title: "",
            id: "",
            upload_path: env.IMG_COMMON_REQUEST_URL_PREFIX + '?type=1',
            upload_agreement_path: env.IMG_COMMON_REQUEST_URL_PREFIX + '?type=99',
            imgUrl: env.IMG_COMMON_URL_PREFIX,
            fileList: [],
            videoList: [],
            addFileList: [],
            allContractUrls: [],
            videoUrl: "",
            thumbUrl: "",
            maxlength: 10000,
            user_role: [
                {
                    id: "1",
                    name: "特属服务对象",
                },
                {
                    id: "3",
                    name: "特属专家",
                },
                {
                    id: "9",
                    name: "所有用户",
                },
                {
                    id: "11",
                    name: "特属服务对象加入条件",
                },
                {
                    id: "31",
                    name: "特属专家加入条件",
                },
            ],
            type: [
                {
                    id: "1",
                    name: "视频",
                },
                {
                    id: "2",
                    name: "多图",
                },
                {
                    id: "3",
                    name: "纯文本",
                },
                {
                    id: "4",
                    name: "图文结合",
                },
                {
                    id: "5",
                    name: "文本+封面",
                },
            ],
            ruleForm: {
                id: "",
                title: "",
                content: "",
                type: "",
                role_id: "",
                thumb: "",
            },
            rules: {
                title: [
                    {required: true, message: "请输入文章标题", trigger: "blur"},
                ],
                role_id: [
                    {required: true, message: "请选择角色类型", trigger: "blur"},
                ],
                type: [
                    {required: true, message: "请选择广告类型", trigger: "blur"},
                ],
                content: [
                    {required: true, message: "请输入宣传广告内容", trigger: "blur"},
                ],
            },
            dialogVisible: false,
            isShow: false,
            dialogPictureVisible: false,
            form_width: "40%",
        };
    },
    methods: {
        roleChange(e) {
            if (e == 31 || e == 11) {
                this.ruleForm.type = '3'
                this.maxlength = ''
            } else {
                this.maxlength = 10000
            }
        },
        // 获取url后缀
        getFileType(url) {
            return fileType(url)
        },
        // 上传视频预览
        handleVideoPreview(file) {
            if (file.url) {
                this.videoUrl = file.url;
            } else {
                this.videoUrl = this.imgUrl + file.response.data
            }

            this.dialogVisible = true;
        },
        // 上传视频
        handleVideoSuccess(res) {
            if (res.code == 0) {
                this.ruleForm.content = res.data;
                this.videoUrl = this.imgUrl + res.data;
                this.isShow = true
            } else {
                this.$message({
                    type: "error",
                    message: res.msg,
                });
            }
        },
        //上传图片之前，检测文件格式
        beforeVideoUpload(file) {
            console.log('type',file.type)
            return ;
            if (file.type === 'video/mp4') {
                var isJPG = true;
            } else {
                var isJPG = false;
            }
            if (!isJPG) {
                this.$message.error('请选择MP4视频文件!');
            }
            return isJPG;
        },
        // 删除视频
        handleVideoRemove(file, fileList){
            this.videoUrl = "";
            this.ruleForm.content = "";
            this.dialogVisible = false;
            this.isShow = false
        },
        // 上传图片成功
        handleSuccess(response, file, fileList) {
            let addFileList = [];
            let imageUrl = this.imgUrl;
            for (let i = 0; i < fileList.length; i++) {
                if (fileList[i].status == 'success') {
                    if (fileList[i].response && fileList[i].response.data) {
                        addFileList.push(fileList[i].response.data);
                    } else {
                        let name = fileList[i].url.substring(imageUrl.length, fileList[i].url.length);
                        let obj = {
                            file: name,
                            x: fileList[i].x,
                            y: fileList[i].y,
                        };
                        addFileList.push(obj);
                    }
                }
            }
            this.addFileList = addFileList;
        },
        // 除去图片
        handleRemove(file) {
            this.$refs.upload.handleRemove(file)
            for (let i=0;i<this.addFileList.length; i++) {
                if (file.response.data.file == this.addFileList[i].file) {
                    this.addFileList.splice(i, 1);
                }
            }
        },
        //上传图片之前，检测文件格式
        beforeUpload(file) {
            let isJPG = false;
            if (file.type === 'image/jpeg' || file.type === 'image/png') {
                isJPG = true;
            } else {
                isJPG = false;
            }

            if (!isJPG) {
                this.$message.error('图片只能是jpg/png格式!');
            }
            return isJPG;
        },
        // 封面上传成功
        handleThumbSuccess(res, file) {
            this.thumbUrl = URL.createObjectURL(file.raw);
            if (res.data) {
                this.ruleForm.thumb = res.data
            } else {
                this.ruleForm.thumb = file.response.data
            }
        },
        // 图片预览
        pictureView(data) {
            this.allContractUrls = [];
            let allContractUrls = [];
            if (data.contract_file) {
                let contract_file = JSON.parse(data.contract_file);
                if (contract_file.length > 0) {
                    for (let i = 0; i < contract_file.length; i++) {
                        let url = this.imgUrl + contract_file[i].file;
                        allContractUrls.push(url);
                    }
                }
            }
            this.allContractUrls = allContractUrls;
            this.dialogPictureVisible = true;
        },
        // 返回上一页
        goBack() {
            window.history.go(-1);
        },

        // 获取详情
        getDetails() {
            let news_params = {
                servername: "Ruyi_ContentServices",
                method: "adDetail",
                params: {
                    id: this.ruleForm.id
                }
            };

            this.$api.service(news_params).then(res => {
                if (!check(res)) {
                    return;
                }
                let data = res.data.data;
                let content = data.content;
                let index = null;
                let name = null;

                if (data.type == 1) {
                    // 视频广告
                    this.ruleForm.content = content;
                    this.videoUrl = this.imgUrl + content
                    this.isShow = true;
                    index = content.lastIndexOf("/");
                    name  = content.substring(index + 1, content.length);
                    this.videoList.push({
                        response: {
                            data: {
                                file: content
                            }
                        },
                        name: name,
                        url: this.imgUrl + content,
                    });

                }
                if (data.type == 4) {
                    // 图文结合广告
                    // 获取文本中的图片地址
                    let imgReg = /<img.*?(?:>|\/>)/gi;
                    let srcReg = /src=[\'\"]?([^\'\"]*)[\'\"]?/i;
                    let allImage = content.match(imgReg);
                    if (allImage) {
                        for (let i = 0; i < allImage.length; i++) {
                            let src = allImage[i].match(srcReg);
                            //获取图片地址
                            if (src[1] && src[1].indexOf("http") == -1 && src[1].indexOf("https") == -1) {
                                content = content.replace(new RegExp(src[1], 'g'), this.imgUrl + src[1]);
                            }
                        }
                    }
                    this.ruleForm['content'] = content;
                }
                if (data.type == 3 || data.type == 5) {
                    // 纯文本
                    this.ruleForm.content = content
                }
                if (data.type == 2) {
                    // 多图广告
                    let file_arr = JSON.parse(data.content)
                    for (let i=0; ;i++) {
                        if (!file_arr[i]) break;
                        index = file_arr[i].file.lastIndexOf("/");
                        name  = file_arr[i].file.substring(index + 1, file_arr[i].file.length);
                        this.fileList.push({
                            response: {
                                data: {
                                    file: file_arr[i].file
                                }
                            },
                            name: name,
                            url: this.imgUrl + file_arr[i].file,
                        });
                        this.addFileList.push({
                            name: name,
                            file: file_arr[i].file,
                        });
                    }
                }
                if (data.role_id == 11 || data.role_id == 31) {
                    this.maxlength = ''
                } else {
                    this.maxlength = 10000
                }
                this.ruleForm.title = data.title;
                this.ruleForm.type = data.type.toString();
                this.ruleForm.role_id = data.role_id.toString();

            });
        },

        // 提交表单
        submitForm(formName) {
            let content = null;
            if (this.ruleForm.type == 2) {
                // 多图
                this.ruleForm.content = this.addFileList
            }

            this.$refs[formName].validate(valid => {
                if (this.ruleForm.type == 4) {
                    // 替换掉图片地址为目录地址
                    content = this.ruleForm.content.replace(new RegExp(env.IMG_COMMON_URL_PREFIX, 'g'), "");
                } else {
                    content = this.ruleForm.content
                }

                if (valid) {
                    let userData = getUserInfos();
                    let params = {
                        'servername': 'Ruyi_ContentServices',
                        'method': 'adSave',
                        'params': {
                            id: this.ruleForm.id,
                            type: this.ruleForm.type,
                            role_id: this.ruleForm.role_id,
                            title: this.ruleForm.title,
                            article_content: content,
                            thumb: this.ruleForm.thumb
                        }
                    };
                    this.$api.service(params).then(res => {
                        if (!check(res)) {
                            return;
                        }

                        this.$message({
                            type: "success",
                            message: '编辑成功',
                            duration: 1500,
                            onClose: function () {
                                window.history.go(-1);
                            }
                        });
                    });
                } else {
                    this.$message({
                        type: "error",
                        message: '请输入必填项'
                    });
                    return false;
                }
            });
        },


    }

};
</script>
<style lang="scss">
@import "@/styles/common.scss";

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 316px;
    height: 200px;
    line-height: 200px;
    text-align: center;
}

.avatar {
    width: 316px;
    height: 200px;
    display: block;
}

.editor {
    line-height: normal !important;
    height: 800px;
}

.upload_btn {
    position: absolute;
    top: 0;
    left: 30px;
}

.file_view {
    position: absolute;
    top: 0;
    left: 130px;
}
.el-select-dropdown.el-popper{
    z-index: 10005 !important;
}

.ql-snow .ql-tooltip[data-mode=link]::before {
    content: "请输入链接地址:";
}

.ql-snow .ql-tooltip.ql-editing a.ql-action::after {
    border-right: 0px;
    content: '保存';
    padding-right: 0px;
}

.video-dialog{
    .el-dialog{
        margin-top: 3vh !important;
        margin-bottom: 20px !important;
    }
}

.ql-snow .ql-tooltip[data-mode=video]::before {
    content: "请输入视频地址:";
}

.ql-snow .ql-picker.ql-size .ql-picker-label::before,
.ql-snow .ql-picker.ql-size .ql-picker-item::before {
    content: '14px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=small]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {
    content: '10px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {
    content: '18px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=huge]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {
    content: '32px';
}

.ql-snow .ql-picker.ql-header .ql-picker-label::before,
.ql-snow .ql-picker.ql-header .ql-picker-item::before {
    content: '文本';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
    content: '标题1';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
    content: '标题2';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
    content: '标题3';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
    content: '标题4';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
    content: '标题5';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
    content: '标题6';
}

.ql-snow .ql-picker.ql-font .ql-picker-label::before,
.ql-snow .ql-picker.ql-font .ql-picker-item::before {
    content: '标准字体';
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=serif]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {
    content: '衬线字体';
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=monospace]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {
    content: '等宽字体';
}
</style>
